import React from 'react';
import OrderDetailsUser from '../order-details-info/order-details-user';
import OrderDetailsDelivery from '../order-details-info/order-details-delivery';
import { getOrderStatus } from 'utils/functions';
import { OrderType } from 'models/order.model';
import OrderDetailsInfo from 'pages/order-details/order-details-info';
import OrderDetailsRider from '../order-details-info/order-details-rider';
import { ENUM_STATUS } from 'utils/enum';
import TrackOrder from 'components/base/track-order';

const CSOrderDetails = ({
  order,
  showChangeAddressModal,
  addressModal
}: {
  order: OrderType;
  showChangeAddressModal: boolean;
  addressModal: () => void;
}) => {
  return (
    <>
      <OrderDetailsUser order={order} />

      <div className='bg-[#F7F7F8] space-y-6 p-5'>
        <div className='flex gap-4 flex-col lg:flex-row '>
          <OrderDetailsDelivery
            order={order}
            show={showChangeAddressModal}
            addressModal={addressModal}
          />
          {order?.rider ? (
            <OrderDetailsRider
              order={order}
              isComplete={getOrderStatus(order) === ENUM_STATUS.COMPLETED}
            />
          ) : null}
        </div>
        <div className='grid min-h-[300px] lg:grid-cols-3 gap-4'>
          <OrderDetailsInfo order={order} />
          <div className='lg:col-span-2'>
            <TrackOrder order={order} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CSOrderDetails;
